import React from 'react';
import { LeftOutlined, RightOutlined } from '@ant-design/icons';

const MediaNavigation = ({ currentIndex, totalItems, onPrevious, onNext, isDarkMode }) => {
  if (totalItems <= 1) return null;
  
  const themeClass = isDarkMode ? 'dark' : 'light';
  
  return (
    <>
      <button 
        className={`nav-button prev-button ${themeClass}`}
        onClick={onPrevious}
        aria-label="Previous item"
      >
        <LeftOutlined />
      </button>
      
      <button 
        className={`nav-button next-button ${themeClass}`}
        onClick={onNext}
        aria-label="Next item"
      >
        <RightOutlined />
      </button>
      
      <div className={`media-counter ${themeClass}`}>
        {currentIndex + 1} / {totalItems}
      </div>
    </>
  );
};

export default MediaNavigation;
